<div class="c-select">
    <button class="c-select__title">{{selectedElement ? selectedElement.opis : domyslnyWiersz}}</button>
    <ul class="c-select__list o-list-bare {{optionPanelOpen ? 'is-open' : ''}}">
        <li *ngFor="let el of list" class="c-select__item {{selectedElement ? el.kod === selectedElement.kod ? 'is-selected' : '' : ''}}" (click)="onSelectionChange(el)">{{el.opis}}</li>
    </ul>
</div>
